import { useEffect, useState } from "react";
import MarkAsCompleteButton from "./MarkAsCompleteButton";
import SaveForLaterButton from "./SaveForLaterButton";

export default function PopupModal({ onClose, children }) {
  const [isVisible, setIsVisible] = useState(false);
  

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 100);

    // Disable scrolling when the modal is open
    document.body.style.overflow = "hidden";
    return () => {
      // Re-enable scrolling when the modal is closed
      document.body.style.overflow = "auto";
    };
  }, []);

  const handleOverlayClick = (e) => {
    // Check if the click is outside the modal content
    if (e.target === e.currentTarget) {
      setIsVisible(false);
      setTimeout(onClose, 30); // Wait for the animation to finish before closing
    }
  };

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 transition-opacity duration-300 ${
        isVisible ? "opacity-100" : "opacity-0"
      }`}
      onClick={handleOverlayClick}
      style={{ visibility: isVisible ? "visible" : "hidden" }}
    >
      <div
        className={`relative bg-white md:w-7/12 w-11/12 p-4 rounded-lg shadow-lg transform transition-transform duration-300 ${
          isVisible ? "scale-100" : "scale-95"
        }`}
      >
        <button
          className="absolute -top-0.5 right-1.5 text-brown hover:text-gray-900 z-10 pointer"
          onClick={() => {
            setIsVisible(false);
            setTimeout(onClose, 1000);
          }}
        >
          &times;
        </button>
        {children}
      </div>
    </div>
  );
}
